import { newClient } from '../axios-client-factory'
import {i18n} from '../../i18n';


export const sendcode = function(opar) {
  console.log(opar);
 let json={
    code:opar.areaCode,
    mobile:opar.mobile,
    lang:i18n.locale,
    recaptchaToken:opar.recaptchaToken
  }
  console.log(json);
  let url;
  if(opar.scene==0){
    // 注册登录发送验证码
    url = '/guild/code/reg/sendCode';
  }else if(opar.scene==1){
    // 修改手机号发送验证码
    url = '/guild/code/update/mobile/sendCode';
  }else if(opar.scene==2){
    // 填写资料发送验证码
    url = '/guild/code/apply/sendCode';
  }else if(opar.scene==3){
    // 个人信息-绑定手机号
    url = '/guild/code/bind/mobile/sendCode';
  }else if(opar.scene==4){
    // 个人信息-换绑手机号
    url = '/guild/code/change/bind/mobile/sendCode';
  } else if(opar.scene==5){
    // 用户忘记密码
    url = '/guild/code/pwd/sendCode';
  }
  console.log(url);
  return newClient().post(url, json)
}

// 获取当前国家信息（code，区号）
export const getCountryMsg = function(code) {
  let thisCode=code;
  if(!thisCode){
    thisCode=getAreaCode()
  }
  return newClient().post(process.env.OLDAPI+'/faceshow/api/Country/getCountryMsg?phone_country='+thisCode)
}
// 国家区号列表 暂时废弃
export const countryListCode = function(json) {
  return newClient().post(process.env.OLDAPI+'/faceshow/api/countrynamemultilingual/list',{},{
    headers: {
      phone_lang: i18n.locale,
      language: i18n.locale,
   }
  })
}

//获取当前国家code
export const getAreaCode = function() {
  let language = navigator.language || navigator.browserLanguage;
  let thisCounty = "";
  if (language.split("-")[1]) {
      thisCounty = language.split("-")[1];
  } else {
      thisCounty = language.split("-")[0];
  }
  let localeLang = thisCounty.toUpperCase();
  let countryCode = localeLang;
  switch (localeLang) {
      case "ZH":
          countryCode = "CN";
          break;
      case "EN":
          countryCode = "GB";
          break;
      case "KO":
          countryCode = "KR";
          break;
      case "RHK":
          countryCode = "HK";
          break;
      case "JA":
          countryCode = "JP";
          break;
      case "VI":
          countryCode = "VN";
          break;
      case "HI":
          countryCode = "IN";
          break;
      default:
          countryCode = localeLang;
          break;
  }
  return countryCode;
}

//获取来源国家
export const anchorCountryArrAjax = function(lang) {
  return newClient().post('/guild/basics/getAllCountry',{
    lang:lang||i18n.locale
  })
}

// 扫码
// 预扫码，生成获取二维码标识

export const generateQrcodeKey = function(type) {
  return newClient().post('/guild/guilder/planScan',{
    lang:i18n.locale,
    scanType:type
  })
}
export const checkQrcode = function(key) {
  return newClient().post('/guild/guilder/scanRound',{
    randNum:key
  })
}



// WEBPACK FOOTER //
// ./src/api/common/index.js